import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { OrderRequestData, PlaceOrZoneType } from "../Domain/RemoteOrderRequests.types";

export function resolveOrderRequestBookingType(placeOrZoneType: PlaceOrZoneType): BookingType {
  if (placeOrZoneType === PlaceOrZoneType.Zone) {
    return BookingType.CONFERENCEZONE;
  }
  if (placeOrZoneType === PlaceOrZoneType.Resource) {
    return BookingType.RESOURCE;
  }
  return BookingType.WORKPLACE;
}

export function isResourceOrderRequest(item: Pick<OrderRequestData, "placeOrZoneType">): boolean {
  return item.placeOrZoneType === PlaceOrZoneType.Resource;
}
